module.exports = __webpack_public_path__ + "atolye1.jpg?951a903285ee5861acc7927718ebe978";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/atolye1.jpg
// module id = 318
// module chunks = 0